module.exports = __webpack_public_path__ + "static/media/CarnationsImg.3f7cb9c9.webp";